var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[(_vm.authStatus === 'failed')?_c('auth-error'):(_vm.authStatus === 'succeeded')?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }